import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement, useCallback, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { mergeRefs } from '../../utils/index.js';
export const Fade = ({
  in: inProperty,
  duration = 300,
  appear = true,
  mountOnEnter = true,
  unmountOnExit = true,
  children,
  onEnter,
  onEntered,
  onEntering,
  onExit,
  onExited,
  onExiting,
  addEndListener,
  ...restProps
}) => {
  const nodeRef = useRef(null);
  const handleExit = useCallback(() => {
    if (nodeRef.current) {
      onExit?.(nodeRef.current);
    }
  }, [onExit]);
  const handleExited = useCallback(() => {
    if (nodeRef.current) {
      onExited?.(nodeRef.current);
    }
  }, [onExited]);
  const handleExiting = useCallback(() => {
    if (nodeRef.current) {
      onExiting?.(nodeRef.current);
    }
  }, [onExiting]);
  const handleEntered = useCallback(isAppearing => {
    if (nodeRef.current) {
      onEntered?.(nodeRef.current, isAppearing);
    }
  }, [onEntered]);
  const handleEntering = useCallback(isAppearing => {
    if (nodeRef.current) {
      onEntering?.(nodeRef.current, isAppearing);
    }
  }, [onEntering]);
  const handleEnter = useCallback(isAppearing => {
    if (nodeRef.current) {
      onEnter?.(nodeRef.current, isAppearing);
    }
  }, [onEnter]);
  const handleAddEndListener = useCallback(done => {
    if (nodeRef.current) {
      addEndListener?.(nodeRef.current, done);
    }
  }, [addEndListener]);
  return _jsx(Transition, {
    ...restProps,
    in: inProperty,
    nodeRef: nodeRef,
    timeout: duration,
    appear: appear,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    children: state => cloneElement(children, {
      ...children.props,
      ref: mergeRefs([nodeRef, 'ref' in children && children.ref]),
      style: {
        ...children.props.style,
        transition: `opacity ${duration}ms ease-in-out`,
        opacity:
        // @ts-expect-error TS(2339) FIXME: Property 'unmounted' does not exist on type '{ ent... Remove this comment to see the full error message
        {
          entering: 1,
          entered: 1,
          exiting: 0,
          exited: 0
        }[state] ?? 0,
        visibility:
        // @ts-expect-error TS(2339) FIXME: Property 'unmounted' does not exist on type '{ ent... Remove this comment to see the full error message
        {
          entering: 'visible',
          entered: 'visible',
          exiting: 'visible',
          exited: 'hidden'
        }[state] ?? 'hidden'
      }
    })
  });
};